import React, { useEffect, useState } from "react";
import { getLinkData, BranchIOLinkData } from "web/script/utils/branch-io";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import Button from "web/react/components/button/button";

interface BranchLinkProps {
    branchLink: string;
    className: string;
    children?: JSX.Element;
    eventAction: string;
    eventCategory: string;
    eventLabel?: string;
    primaryButton?: boolean;
    title: string;
}

function BranchLink({
    title,
    className,
    children,
    eventCategory,
    eventAction,
    eventLabel,
    branchLink,
    primaryButton,
}: BranchLinkProps): JSX.Element {
    let trackedClick = useClickTracker(eventCategory, eventAction, eventLabel);

    const branchReferralLink = new URL(branchLink);
    const [branchHref, setBranchHref] = useState(branchLink.toString());

    useEffect(() => {
        const branchIOLinkData: BranchIOLinkData = getLinkData();
        for (const branchDataProperty in branchIOLinkData) {
            branchReferralLink.searchParams.set(
                branchDataProperty,
                branchIOLinkData[branchDataProperty]
            );
        }

        setBranchHref(branchReferralLink.toString());
    }, [branchReferralLink]);

    if (primaryButton) {
        return (
            <Button
                onClick={trackedClick}
                styleType="primary"
                href={branchHref}
                disabled={false}
                fullWidth={true}
                fullHeight={false}
                openInNewTab={false}
                className={className}
                aria-label={title}
            >
                {title}
            </Button>
        );
    }

    return (
        <a
            onClick={trackedClick}
            className={className}
            href={branchHref}
            title={title}
            aria-label={title}
        >
            {children}
        </a>
    );
}

export default BranchLink;
